import { User } from './User.model';

export class Organization {
  name: string;
  jenkinsMaxWorkers: number;
  users: User [];
  admins: User [];
  shortName: string;
  urls: IUrls[];
  jenkinsConfig: string;
  isDuplicatedAdmin: boolean = false;
  isDuplicatedUser: boolean = false;
  latam: number;
  grafana: number ;
  atLeastOneAdmin: boolean = false;
  saved: number;

  constructor() {
    this.jenkinsMaxWorkers = 1;
    this.name = '';
    this.shortName = '';
    this.admins = [];
    this.users = [];
    this.jenkinsConfig = '';
    this.grafana;
    this.latam;

  }
}

export interface IUrls {
  id: string;
  value: string;
}
